
export default (editor, options) => {
    editor.TraitManager.addType('hide', {
        createLabel({ label }) {
            return '';
          },
        createInput({ component, trait }) {
            return ''
        }
    })
}